import { Colors } from '@fourthwall/components';
import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  position: relative;
  padding: 12px 16px;
  border: 1px solid ${Colors.GS500};
  cursor: pointer;

  & + & {
    margin-top: -1px;
    border-top-color: transparent;
  }

  ${({ selected }) => selected &&
    css `
      padding: 11px 15px;
      border: 2px solid ${Colors.GS1000};
      border-top-color: ${Colors.GS1000} !important;
    `}
`;
export const RadioContainer = styled.div `
  margin-right: 14px;
`;
export const Content = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Label = styled.div `
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: ${Colors.GS600};
  margin-bottom: 4px;
`;
export const Text = styled.div `
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`;
export const SavingsTag = styled.div `
  position: absolute;
  top: 0;
  right: 0;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #fdfcfb;
  background: linear-gradient(#d82792, #3621b6);
  background: radial-gradient(128.44% 143.02% at 96.27% -10.78%, #d82792 0%, #3621b6 100%);
`;
